import { render } from "./stock.vue?vue&type=template&id=e5ed93ba&ts=true"
import script from "./stock.vue?vue&type=script&lang=ts"
export * from "./stock.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/mysystem_data_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__